import Seo from "@/components/feature/Seo";
import LegalBody, { type LegalSection } from "@/pages/legal/components/LegalBody";

const sections: LegalSection[] = [
  {
    heading: "1. Information We Collect",
    paragraphs: [
      "When you submit an enquiry through this website, we collect the information you choose to provide. This may include your name, company, mobile number, email address, city, enquiry type and the message you send, along with vehicle details where you submit a retrofit eligibility or fleet enquiry.",
      "We do not ask for information that is not needed to respond to your enquiry, and we do not store unnecessary sensitive information.",
    ],
  },
  {
    heading: "2. How We Use Your Information",
    paragraphs: [
      "Your information is used to review and respond to your enquiry, to route it to the relevant team, and to carry out a technical assessment where relevant.",
      "We may contact you using the details you provide in order to discuss your enquiry. We do not sell your information.",
    ],
  },
  {
    heading: "3. Vehicle Photos and Documents",
    paragraphs: [
      "Where you choose to provide vehicle photographs or documents, these are used only for the purpose of assessing a potential retrofit. Please only share documents that are legally appropriate and necessary for your enquiry.",
    ],
  },
  {
    heading: "4. Consent and Your Choices",
    paragraphs: [
      "Enquiry forms include a consent confirmation. You may request information about the details we hold about you, or ask us to update or remove them, by contacting us through the official enquiry channel.",
    ],
  },
  {
    heading: "5. Data Security",
    paragraphs: [
      "We take reasonable measures to protect the information submitted through this website. Access is limited to the teams that need it to respond to your enquiry.",
    ],
  },
  {
    heading: "6. Changes to This Policy",
    paragraphs: [
      "This policy may be updated from time to time. The latest version will be published on this page.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="Privacy Policy | KAL LORDS ZERO21 DJT"
        description="How KAL LORDS ZERO21 DJT collects, uses and protects the information you submit through enquiry forms on this website."
        path="/privacy-policy"
      />
      <LegalBody
        breadcrumb="Privacy Policy"
        title="Privacy Policy"
        description="This policy explains what information we collect through this website, how it is used and the choices available to you."
        updated="September 2026"
        sections={sections}
      />
    </>
  );
}